export default __webpack_public_path__ + "static/benefits_2-8d7dcc7dad6f6d1c407fcabb4751c44a.webp";